/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Rocket.net API
 * Rocket.net - All APIs
 * OpenAPI spec version: 1.0.0
 */
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import { customFetch } from '../../custom-fetch';
import { addMetaToQuery } from '../../mutators/add-meta';
import type { AppPartnerInstalledPluginsResponse, Error } from '../rocketNetAPI.schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Returns domains where your plugin is installed across Rocket.net sites and the total installation count.
 * @summary List plugin installations
 */
export const listInstalledPlugins = (signal?: AbortSignal) => {
  return customFetch<AppPartnerInstalledPluginsResponse>({
    url: `/app_partner/v1/installed_plugins`,
    method: 'GET',
    signal,
  });
};

export const getListInstalledPluginsQueryKey = () => {
  return [`/app_partner/v1/installed_plugins`] as const;
};

export const getListInstalledPluginsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInstalledPlugins>>,
  TError = Error,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listInstalledPlugins>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListInstalledPluginsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listInstalledPlugins>>> = ({ signal }) =>
    listInstalledPlugins(signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    {},
    {
      url: `/app_partner/v1/installed_plugins`,
      operationId: 'app.controllers.featured_plugins_controller.list_installed_plugins',
      operationName: 'listInstalledPlugins',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listInstalledPlugins>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListInstalledPluginsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInstalledPlugins>>
>;
export type ListInstalledPluginsQueryError = Error;

export function useListInstalledPlugins<
  TData = Awaited<ReturnType<typeof listInstalledPlugins>>,
  TError = Error,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listInstalledPlugins>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInstalledPlugins>>,
          TError,
          Awaited<ReturnType<typeof listInstalledPlugins>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListInstalledPlugins<
  TData = Awaited<ReturnType<typeof listInstalledPlugins>>,
  TError = Error,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listInstalledPlugins>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInstalledPlugins>>,
          TError,
          Awaited<ReturnType<typeof listInstalledPlugins>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListInstalledPlugins<
  TData = Awaited<ReturnType<typeof listInstalledPlugins>>,
  TError = Error,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listInstalledPlugins>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List plugin installations
 */

export function useListInstalledPlugins<
  TData = Awaited<ReturnType<typeof listInstalledPlugins>>,
  TError = Error,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listInstalledPlugins>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListInstalledPluginsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListInstalledPluginsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listInstalledPlugins>>,
  TError = Error,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInstalledPlugins>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListInstalledPluginsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listInstalledPlugins>>> = ({ signal }) =>
    listInstalledPlugins(signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    {},
    {
      url: `/app_partner/v1/installed_plugins`,
      operationId: 'app.controllers.featured_plugins_controller.list_installed_plugins',
      operationName: 'listInstalledPlugins',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listInstalledPlugins>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListInstalledPluginsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInstalledPlugins>>
>;
export type ListInstalledPluginsSuspenseQueryError = Error;

export function useListInstalledPluginsSuspense<
  TData = Awaited<ReturnType<typeof listInstalledPlugins>>,
  TError = Error,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInstalledPlugins>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListInstalledPluginsSuspense<
  TData = Awaited<ReturnType<typeof listInstalledPlugins>>,
  TError = Error,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInstalledPlugins>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListInstalledPluginsSuspense<
  TData = Awaited<ReturnType<typeof listInstalledPlugins>>,
  TError = Error,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInstalledPlugins>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List plugin installations
 */

export function useListInstalledPluginsSuspense<
  TData = Awaited<ReturnType<typeof listInstalledPlugins>>,
  TError = Error,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listInstalledPlugins>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListInstalledPluginsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
